import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, Drawer, Layout, Menu } from 'antd';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '@/redux/auth/selectors';
import { useAppContext } from '@/context/appContext';
import history from '@/utils/history';
import role from '@/config/roleConfig';

import {
  SettingOutlined,
  CustomerServiceOutlined,
  FileTextOutlined,
  FileSyncOutlined,
  DashboardOutlined,
  TeamOutlined,
  UserOutlined,
  MenuOutlined,
  UserAddOutlined,
  FileOutlined,
  FileDoneOutlined,
} from '@ant-design/icons';

const SIDEBAR_MENU = [
  { key: 'dashboard', icon: <DashboardOutlined />, title: 'Dashboard' },
  { key: 'inventory/category', icon: <FileTextOutlined />, title: 'Inventory' },
  { key: 'customer', icon: <CustomerServiceOutlined />, title: 'Customer' },
  { key: 'saleOrder', icon: <FileSyncOutlined />, title: 'Sale Order' },
  { key: 'sales', icon: <FileDoneOutlined />, title: 'Sales' },
  { key: 'employee', icon: <UserOutlined />, title: 'Employee' },
  { key: 'user', icon: <TeamOutlined />, title: 'User' },
  { key: 'lead', icon: <UserAddOutlined />, title: 'Lead' },
  { key: 'offer', icon: <FileOutlined />, title: 'Offer' },
];

const SETTINGS_SUBMENU = [
  { key: '/settings', title: 'General Settings' },
  // { key: '/email', title: 'Email templates' },
  { key: '/settings/advanced', title: 'Advanced Settings' },
];

const { Sider } = Layout;
const { SubMenu } = Menu;

export default function Navigation() {
  return (
    <>
      <div className="sidebar-wraper">
        <Sidebar collapsible={true} />
      </div>
      <MobileSidebar />
    </>
  );
}

function Sidebar({ collapsible }) {
  let location = useLocation();

  const { state: stateApp, appContextAction } = useAppContext();
  const user = useSelector(selectCurrentUser);

  const { isNavMenuClose } = stateApp;
  const { navMenu } = appContextAction;
  const [showLogoApp, setLogoApp] = useState(isNavMenuClose);
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const [menuList, setMenuList] = useState(SIDEBAR_MENU);
  const [menuSetting, setMenuSetting] = useState([]);

  const entity = location.pathname.split('/');

  useEffect(() => {
    switch (user?.role) {
      case 'super admin':
        let all_menu = role['super admin']['side_menu'];
        setMenuSetting(SETTINGS_SUBMENU);
        setMenuList((state) => {
          return state.filter((menu) => {
            return all_menu.includes(menu.key);
          });
        });
        break;
      case 'admin':
        let admin_menu = role['admin']['side_menu'];
        setMenuSetting(SETTINGS_SUBMENU);
        setMenuList((state) => {
          return state.filter((menu) => {
            return admin_menu.includes(menu.key);
          });
        });
        break;
      case 'staff':
        let staff_menu = role['staff']['side_menu'];
        setMenuList((state) => {
          return state.filter((menu) => {
            return staff_menu.includes(menu.key);
          });
        });
        break;
      case 'executive':
        let executive_menu = role['executive']['side_menu'];
        setMenuSetting([]);
        setMenuList((state) => {
          return state.filter((menu) => {
            return executive_menu.includes(menu.key);
          });
        });
        break;
      default:
        let default_menu = ['Dashboard', 'Inventory', 'Customer', 'Sale Order', 'Sales'];
        setMenuList((state) => {
          return state.filter((menu) => {
            return default_menu.includes(menu.key);
          });
        });
    }
  }, [user]);

  useEffect(() => {
    if (location) if (currentPath !== location.pathname) setCurrentPath(location.pathname);
  }, [location, currentPath]);

  useEffect(() => {
    if (isNavMenuClose) {
      setLogoApp(isNavMenuClose);
    }
    const timer = setTimeout(() => {
      if (!isNavMenuClose) {
        setLogoApp(isNavMenuClose);
      }
    }, 200);
    return () => clearTimeout(timer);
  }, [isNavMenuClose]);
  const onCollapse = () => {
    navMenu.collapse();
  };

  return (
    <>
      <Sider
        collapsible={true}
        // collapsed={collapsible ? isNavMenuClose : collapsible}
        onCollapse={onCollapse}
        className="navigation"
      >
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <img
            style={{ margin: 'auto', padding: '10px' }}
            src="https://www.hailoworld.com/image/hailoBrownLogo.svg"
            width={`${!showLogoApp ? '130px' : '250px'}`}
            height={`${!showLogoApp ? '60px' : '40px'}`}
          />
        </div>

        {/* <div className="logo" >
          {
           
            // <svg
            //   width={`${!showLogoApp ? '130' : '250'}`}
            //   height="58.782446291244"
            //   viewBox="0 0 370 50.698147150956366"
            //   className="css-1j8o68f"
            // >
            //   <defs id="SvgjsDefs1204"></defs>
            //   <g
            //     id="SvgjsG1205"
            //     featurekey="symbolFeature-0"
            //     transform="matrix(0.7479253822350767,0,0,0.7479253822350767,-2.3954385004222605,-12.096801909463519)"
            //     fill="#111111"
            //   >
            //     <g xmlns="http://www.w3.org/2000/svg">
            //       <rect
            //         x="12.791"
            //         y="42.427"
            //         transform="matrix(0.9852 -0.1715 0.1715 0.9852 -7.1501 4.6061)"
            //         width="20.594"
            //         height="2.534"
            //       ></rect>
            //       <rect
            //         x="18.904"
            //         y="38.404"
            //         transform="matrix(0.1715 0.9852 -0.9852 0.1715 65.3756 21.0534)"
            //         width="2.535"
            //         height="21.981"
            //       ></rect>
            //       <rect
            //         x="20.914"
            //         y="51.604"
            //         transform="matrix(-0.9852 0.1715 -0.1715 -0.9852 68.7011 99.807)"
            //         width="18.253"
            //         height="2.533"
            //       ></rect>
            //       <rect
            //         x="3.112"
            //         y="57.838"
            //         transform="matrix(0.9852 -0.1714 0.1714 0.9852 -9.7766 4.9994)"
            //         width="41.891"
            //         height="2.534"
            //       ></rect>
            //       <path d="M40.454,73.725c2.704-0.471,4.629-2.771,4.729-5.406l35.666-6.207c0.985,2.448,3.572,3.962,6.275,3.492   c2.702-0.471,4.627-2.771,4.729-5.406l4.942-0.86l-3.682-21.155L76.12,24.196l-53.34,9.282l0.594,3.409l2.496-0.434l-0.159-0.914   l49.697-8.648l15.369,12.649l3.086,17.733l-2.48,0.432c-1.024-2.366-3.564-3.819-6.217-3.357c-2.654,0.462-4.552,2.688-4.716,5.26   l-35.737,6.219c-1.023-2.366-3.563-3.819-6.217-3.357c-2.653,0.462-4.553,2.688-4.716,5.26l-2.396,0.417l-0.701-4.029l2.153-0.374   l-0.435-2.497l-17.37,3.022l0.435,2.497l12.721-2.214l1.136,6.526l4.855-0.846c0.861,2.142,2.949,3.567,5.268,3.577H17.5v1.994   h77.783V73.81H39.452C39.782,73.811,40.117,73.783,40.454,73.725z M85.531,56.444c1.951-0.339,3.808,0.967,4.146,2.917   c0.34,1.95-0.966,3.806-2.917,4.146c-1.95,0.339-3.807-0.967-4.146-2.917C82.275,58.64,83.581,56.784,85.531,56.444z    M35.944,68.711c-0.339-1.95,0.967-3.806,2.917-4.146c1.95-0.339,3.806,0.967,4.146,2.917c0.339,1.95-0.966,3.806-2.917,4.146   C38.14,71.967,36.284,70.661,35.944,68.711z"></path>
            //       <polygon points="71.571,43.216 73.991,42.795 84.525,40.962 84.104,38.542 73.57,40.375 71.737,29.842 69.317,30.263 71.15,40.796     "></polygon>
            //       <path d="M43.758,49.736l-1.722,0.307c-0.457,0.083-0.756,0.551-0.667,1.049c0.088,0.493,0.531,0.828,0.989,0.745l27.431-4.9   c0.458-0.082,0.758-0.551,0.67-1.046c-0.089-0.497-0.534-0.832-0.99-0.75l-1.722,0.308c-1.754-5.151-6.953-8.498-12.599-8.022   l-0.101-0.569c-0.172-0.956-0.836-1.638-1.486-1.522c-0.649,0.116-1.036,0.986-0.866,1.943l0.103,0.568   C47.338,39.356,43.621,44.296,43.758,49.736z"></path>
            //     </g>
            //   </g>
            //   <g
            //     id="SvgjsG1206"
            //     featurekey="nameFeature-0"
            //     transform="matrix(1.757910779567284,0,0,1.757910779567284,87.18734166298401,-20.32145270239524)"
            //     fill="#111111"
            //   >
            //     <path d="M22 39.32 c0 -0.16 -0.04 -0.32 -0.2 -0.48 c-0.12 -0.12 -0.28 -0.16 -0.48 -0.16 l-0.64 0.04 c-0.32 0 -0.52 -0.28 -0.52 -0.76 l0 -9.68 c0 -2 -0.4 -3.44 -1.24 -4.36 c-0.84 -0.96 -2.16 -1.4 -3.96 -1.4 c-1.48 0 -2.72 0.36 -3.76 1.04 c-0.72 0.48 -1.32 1.08 -1.84 1.84 c-0.08 0.12 -0.24 0.16 -0.4 0.12 s-0.24 -0.16 -0.24 -0.36 l0 -8.56 c0 -0.16 -0.08 -0.32 -0.2 -0.44 s-0.28 -0.2 -0.44 -0.2 l-5.84 0 c-0.2 0 -0.32 0.08 -0.44 0.2 c-0.16 0.12 -0.2 0.28 -0.2 0.44 c0 0.2 0.04 0.36 0.2 0.48 c0.12 0.12 0.28 0.2 0.48 0.16 l0.64 -0.04 c0.36 0.08 0.52 0.36 0.52 0.8 l0 19.96 c0 0.4 -0.16 0.68 -0.52 0.76 l-0.64 -0.04 c-0.16 0 -0.36 0.04 -0.48 0.16 c-0.12 0.16 -0.2 0.32 -0.2 0.48 c0 0.2 0.04 0.36 0.2 0.48 c0.12 0.12 0.28 0.2 0.44 0.2 l7.88 0 c0.2 0 0.36 -0.08 0.48 -0.2 s0.2 -0.28 0.2 -0.48 c0 -0.16 -0.08 -0.32 -0.2 -0.48 c-0.12 -0.12 -0.32 -0.16 -0.48 -0.16 l-0.88 0.04 c-0.36 0 -0.52 -0.28 -0.52 -0.76 l0 -5.92 c0 -1.6 0.2 -3 0.64 -4.12 c0.44 -1.16 0.96 -2.04 1.64 -2.64 c0.64 -0.6 1.32 -0.88 2 -0.88 c0.8 0 1.32 0.28 1.56 0.84 s0.32 1.56 0.32 3 l0 9.72 c0 0.4 -0.16 0.68 -0.52 0.76 l-0.8 -0.04 c-0.2 0 -0.36 0.04 -0.52 0.16 c-0.12 0.16 -0.2 0.32 -0.2 0.48 c0 0.2 0.08 0.36 0.2 0.48 s0.28 0.2 0.48 0.2 l7.84 0 c0.16 0 0.32 -0.08 0.48 -0.2 c0.12 -0.12 0.16 -0.28 0.16 -0.48 z M41.28 39.32 c0 -0.16 -0.08 -0.32 -0.2 -0.48 c-0.16 -0.12 -0.32 -0.16 -0.52 -0.16 l-0.6 0.04 c-0.36 0 -0.56 -0.28 -0.52 -0.76 l0 -10.12 c0 -3.56 -2.52 -5.32 -7.48 -5.32 c-2.28 0 -4.12 0.4 -5.44 1.16 c-1.36 0.76 -2 1.8 -2 3.08 c0 0.68 0.24 1.24 0.68 1.68 c0.48 0.44 1.08 0.68 1.84 0.68 c0.64 0 1.16 -0.16 1.6 -0.48 c0.4 -0.32 0.6 -0.8 0.6 -1.4 c0 -0.16 -0.04 -0.4 -0.16 -0.8 c-0.12 -0.24 -0.2 -0.56 -0.2 -0.92 c0 -0.44 0.2 -0.84 0.6 -1.16 c0.36 -0.32 1.04 -0.48 2 -0.48 c1.08 0 1.8 0.28 2.16 0.84 c0.32 0.56 0.52 1.36 0.52 2.36 l0 1.96 c0 0.24 -0.08 0.44 -0.24 0.6 c-0.2 0.16 -0.4 0.28 -0.64 0.28 c-3.24 0.08 -5.68 0.52 -7.24 1.4 c-1.72 0.92 -2.56 2.4 -2.56 4.32 c0 1.52 0.4 2.64 1.28 3.4 s2.16 1.16 3.84 1.16 c1.28 0 2.32 -0.28 3.16 -0.8 s1.48 -1.04 1.88 -1.52 c0.08 -0.08 0.2 -0.12 0.32 -0.04 c0.12 0.04 0.16 0.16 0.16 0.28 l0 0.4 c0 0.44 0.16 0.76 0.44 1.04 s0.64 0.44 1.04 0.44 l5 0 c0.2 0 0.36 -0.08 0.48 -0.2 s0.2 -0.28 0.2 -0.48 z M33.04 36.76 c-0.6 0.72 -1.32 1.08 -2.16 1.08 c-1.28 0 -1.96 -0.88 -1.96 -2.68 c0 -1.28 0.44 -2.24 1.24 -2.88 c0.68 -0.52 1.68 -0.84 3.04 -0.92 c0.24 -0.04 0.48 0.04 0.68 0.24 c0.2 0.16 0.28 0.36 0.28 0.64 l0 1.72 c-0.16 1.16 -0.52 2.08 -1.12 2.8 z M46.8 19.48 c-0.72 0 -1.36 -0.24 -1.84 -0.76 c-0.52 -0.52 -0.8 -1.12 -0.8 -1.84 c0 -0.76 0.28 -1.36 0.8 -1.88 c0.48 -0.52 1.12 -0.76 1.84 -0.76 s1.36 0.24 1.88 0.76 s0.76 1.12 0.76 1.88 c0 0.72 -0.24 1.32 -0.76 1.84 s-1.16 0.76 -1.88 0.76 z M50.599999999999994 38.68 c0.16 0 0.36 0.04 0.48 0.16 c0.12 0.16 0.2 0.32 0.2 0.48 c0 0.2 -0.04 0.36 -0.2 0.48 c-0.12 0.12 -0.28 0.2 -0.44 0.2 l-7.64 0 c-0.2 0 -0.36 -0.08 -0.48 -0.2 s-0.2 -0.28 -0.2 -0.48 c0 -0.16 0.08 -0.32 0.2 -0.48 c0.16 -0.12 0.32 -0.16 0.52 -0.16 l0.6 0.04 l0.08 0 c0.32 0 0.44 -0.28 0.44 -0.76 l0 -13 c0 -0.44 -0.16 -0.72 -0.48 -0.8 l-0.64 0.04 c-0.2 0 -0.36 -0.04 -0.48 -0.16 c-0.12 -0.16 -0.2 -0.28 -0.2 -0.48 c0 -0.16 0.08 -0.32 0.2 -0.44 c0.12 -0.16 0.28 -0.2 0.44 -0.2 l5.8 0 c0.16 0 0.32 0.04 0.44 0.2 c0.12 0.12 0.2 0.28 0.2 0.44 l0 14.4 c0 0.52 0.16 0.8 0.52 0.76 z M52.43999999999999 39.32 l0 0.04 c0 0.16 0.04 0.32 0.16 0.44 c0.16 0.12 0.32 0.2 0.48 0.2 l7.64 0 c0.2 0 0.36 -0.08 0.48 -0.2 s0.2 -0.28 0.2 -0.44 l0 -0.04 c0 -0.16 -0.08 -0.32 -0.2 -0.48 c-0.16 -0.12 -0.32 -0.16 -0.52 -0.16 l-0.6 0.04 c-0.36 0.04 -0.52 -0.24 -0.52 -0.76 l0 -21.4 c0 -0.16 -0.08 -0.32 -0.2 -0.44 s-0.28 -0.2 -0.44 -0.2 l-5.84 0 c-0.16 0 -0.32 0.08 -0.44 0.2 s-0.16 0.28 -0.16 0.44 s0.04 0.32 0.16 0.44 c0.16 0.12 0.32 0.2 0.48 0.16 l0.68 -0.04 c0.32 0.12 0.48 0.4 0.48 0.84 l0 20 c0 0.4 -0.16 0.68 -0.52 0.76 l-0.64 -0.04 c-0.2 0 -0.36 0.04 -0.48 0.16 c-0.16 0.16 -0.2 0.32 -0.2 0.48 z M65.11999999999999 24.880000000000003 c1.48 -1.52 3.72 -2.28 6.72 -2.28 s5.24 0.76 6.72 2.28 s2.2 3.72 2.2 6.6 c0 5.96 -2.96 8.92 -8.92 8.92 c-3 0 -5.24 -0.76 -6.72 -2.28 s-2.24 -3.72 -2.24 -6.64 c0 -2.88 0.76 -5.08 2.24 -6.6 z M69.27999999999999 37.28 c0.52 1.16 1.36 1.72 2.56 1.72 s2.04 -0.56 2.56 -1.68 s0.76 -3.04 0.76 -5.76 c0 -2.76 -0.24 -4.72 -0.76 -5.88 s-1.36 -1.72 -2.56 -1.72 s-2.04 0.56 -2.56 1.72 s-0.8 3.12 -0.8 5.88 c0 2.68 0.28 4.6 0.8 5.72 z M90.8 39.32 c0 0.2 0.08 0.36 0.2 0.48 c0.16 0.12 0.32 0.2 0.48 0.2 l8.96 0 c0.2 0 0.36 -0.08 0.48 -0.2 s0.2 -0.28 0.2 -0.48 s-0.08 -0.36 -0.2 -0.48 c-0.16 -0.12 -0.32 -0.2 -0.48 -0.2 l-1.84 0.08 c-0.32 0 -0.52 -0.28 -0.52 -0.76 l0 -13.12 c0 -0.16 0.08 -0.32 0.2 -0.44 s0.28 -0.2 0.44 -0.2 l1.88 0 c0.16 0 0.32 -0.08 0.44 -0.2 s0.2 -0.28 0.2 -0.44 s-0.08 -0.32 -0.2 -0.44 c-0.12 -0.16 -0.28 -0.2 -0.44 -0.2 l-1.92 0 c-0.16 0 -0.32 -0.08 -0.44 -0.2 s-0.2 -0.28 -0.2 -0.44 l0 -0.32 c0 -0.16 0 -0.36 -0.04 -0.64 c-0.04 -0.16 -0.04 -0.4 -0.08 -0.64 c0 -0.24 -0.04 -0.6 -0.04 -1 c0 -0.24 0 -0.48 -0.04 -0.64 c0 -0.52 -0.04 -1.12 -0.04 -1.76 c0 -1.64 0.2 -2.8 0.6 -3.4 c0.4 -0.64 1 -0.96 1.72 -0.96 c0.48 0 0.88 0.16 1.12 0.52 s0.36 0.76 0.36 1.24 c0 0.36 -0.08 0.68 -0.2 1 c-0.12 0.4 -0.16 0.68 -0.16 0.84 c0 0.52 0.2 0.92 0.6 1.2 c0.44 0.28 0.96 0.44 1.56 0.44 c0.84 0 1.52 -0.24 1.92 -0.72 c0.44 -0.52 0.64 -1.08 0.64 -1.76 c0 -1.12 -0.56 -2.12 -1.64 -2.92 c-1.12 -0.8 -2.52 -1.2 -4.12 -1.2 c-2.8 0 -4.72 1 -5.8 2.96 c-1.04 2.24 -1.56 4.72 -1.56 7.48 l0 0.28 c0 0.16 -0.08 0.32 -0.2 0.44 s-0.28 0.2 -0.44 0.2 l-0.28 0 c-0.2 0 -0.36 0.04 -0.48 0.2 c-0.12 0.12 -0.16 0.28 -0.16 0.44 s0.04 0.32 0.16 0.44 s0.28 0.2 0.48 0.2 l0.28 0 c0.16 0 0.32 0.08 0.44 0.2 s0.2 0.28 0.2 0.44 l0 13.12 c0 0.48 -0.2 0.76 -0.52 0.76 l-0.8 -0.04 c-0.2 0 -0.36 0.04 -0.48 0.16 c-0.16 0.16 -0.24 0.32 -0.24 0.48 z M104.75999999999999 24.880000000000003 c1.48 -1.52 3.72 -2.28 6.72 -2.28 s5.24 0.76 6.72 2.28 s2.2 3.72 2.2 6.6 c0 5.96 -2.96 8.92 -8.92 8.92 c-3 0 -5.24 -0.76 -6.72 -2.28 s-2.24 -3.72 -2.24 -6.64 c0 -2.88 0.76 -5.08 2.24 -6.6 z M108.91999999999999 37.28 c0.52 1.16 1.36 1.72 2.56 1.72 s2.04 -0.56 2.56 -1.68 s0.76 -3.04 0.76 -5.76 c0 -2.76 -0.24 -4.72 -0.76 -5.88 s-1.36 -1.72 -2.56 -1.72 s-2.04 0.56 -2.56 1.72 s-0.8 3.12 -0.8 5.88 c0 2.68 0.28 4.6 0.8 5.72 z M124.24 24.880000000000003 c1.48 -1.52 3.72 -2.28 6.72 -2.28 s5.24 0.76 6.72 2.28 s2.2 3.72 2.2 6.6 c0 5.96 -2.96 8.92 -8.92 8.92 c-3 0 -5.24 -0.76 -6.72 -2.28 s-2.24 -3.72 -2.24 -6.64 c0 -2.88 0.76 -5.08 2.24 -6.6 z M128.39999999999998 37.28 c0.52 1.16 1.36 1.72 2.56 1.72 s2.04 -0.56 2.56 -1.68 s0.76 -3.04 0.76 -5.76 c0 -2.76 -0.24 -4.72 -0.76 -5.88 s-1.36 -1.72 -2.56 -1.72 s-2.04 0.56 -2.56 1.72 s-0.8 3.12 -0.8 5.88 c0 2.68 0.28 4.6 0.8 5.72 z M143.35999999999999 24.8 c-1.2 1.48 -1.8 3.76 -1.8 6.72 c0 3.04 0.56 5.28 1.68 6.72 s2.96 2.16 5.56 2.16 c1.28 0 2.32 -0.24 3.12 -0.8 c0.52 -0.36 0.92 -0.8 1.24 -1.32 c0.08 -0.08 0.16 -0.12 0.28 -0.08 s0.16 0.12 0.16 0.24 l-0.04 0.92 c0 0.2 0.08 0.32 0.2 0.44 s0.28 0.2 0.44 0.2 l6 0 c0.2 0 0.36 -0.08 0.48 -0.2 s0.2 -0.28 0.2 -0.48 c0 -0.16 -0.08 -0.32 -0.2 -0.48 c-0.16 -0.12 -0.32 -0.16 -0.52 -0.16 l-0.6 0.04 c-0.36 0 -0.52 -0.28 -0.52 -0.76 l0 -21.36 c0 -0.16 -0.08 -0.32 -0.2 -0.44 s-0.28 -0.2 -0.44 -0.2 l-6.4 0 c-0.16 0 -0.32 0.08 -0.44 0.2 s-0.16 0.28 -0.16 0.44 s0.04 0.32 0.2 0.44 c0.12 0.12 0.28 0.2 0.44 0.2 l1.2 -0.08 c0.36 0 0.52 0.28 0.52 0.8 l0 4.56 c0 0.44 -0.2 0.8 -0.56 1 c-0.4 0.2 -0.76 0.16 -1.16 -0.08 l-0.08 -0.04 c-0.88 -0.6 -1.96 -0.88 -3.2 -0.88 c-2.36 0 -4.16 0.76 -5.4 2.28 z M147.44 35.68 c-0.2 -0.96 -0.28 -2.36 -0.28 -4.16 c0 -2.36 0.24 -4.16 0.68 -5.36 c0.44 -1.24 1.2 -1.84 2.28 -1.84 c1.12 0 2.04 0.56 2.64 1.72 c0.6 1.12 0.92 2.72 0.92 4.76 l0 1.72 c0 2 -0.28 3.52 -0.88 4.52 c-0.56 1 -1.44 1.52 -2.64 1.52 c-0.8 0 -1.4 -0.24 -1.84 -0.68 c-0.4 -0.48 -0.72 -1.2 -0.88 -2.2 z"></path>
            //   </g>
            // </svg>
          }
        </div> */}
        <Menu mode="inline" selectedKeys={[currentPath]}>
          {menuList.map((menuItem) => (
            <Menu.Item
              className={`${
                entity[1] == menuItem.key.split('/')[0] ? 'ant-menu-item-selected' : ''
              }`}
              key={menuItem.key}
              icon={menuItem.icon}
            >
              <Link to={'/' + menuItem.key} />
              {menuItem.title}
            </Menu.Item>
          ))}
          {/* {menuSetting.length > 0 && (
              <SubMenu key={'Settings'} icon={<SettingOutlined />} title={'Settings'}>
              {menuSetting.map((menuItem) => (
                <Menu.Item key={menuItem.key}>
                  <Link to={'/'+menuItem.key} />
                  {menuItem.title}
                </Menu.Item>
              ))}
            </SubMenu>
          )} */}
        </Menu>
      </Sider>
    </>
  );
}

function MobileSidebar() {
  const [visible, setVisible] = useState(false);
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  return (
    <>
      <Button type="text" size="large" onClick={showDrawer} className="mobile-sidebar-btn">
        <MenuOutlined />
      </Button>
      <Drawer
        width={200}
        placement="left"
        closable={false}
        onClose={onClose}
        visible={visible}
        className="mobile-sidebar-wraper"
      >
        <Sidebar collapsible={false} />
      </Drawer>
    </>
  );
}
